<!-- <p>risk-line-graph works!</p> -->
<div class="demo-chart-wrapper">
  <div
    echarts
    id="chartRisk"
    [options]="chartOption"
    [ngStyle]="height ? { height: height } : {}"
    class="demo-chart"
  ></div>
</div>
